import { requiredRule } from "@/app/fields/commonFormFieldProps";
import { Entity, IField } from "@/app/fields/types";
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from "@chakra-ui/react";
import { ControllerProps, useFormContext } from "@saas-ui/forms";
import React from "react";
import { Controller, FormState, get } from "react-hook-form";

export const CustomField = <T extends Entity>({
  field,
  render,
  isDisabled,
  addOption,
}: {
  field: IField<T>;
  render: ControllerProps["render"];
  isDisabled?: boolean;
  addOption?: React.ReactNode;
}) => {
  const { control, formState, getFieldState } = useFormContext();
  const error = getError(String(field.field), formState);
  const { invalid } = getFieldState(String(field.field), formState);
  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={invalid}
      isRequired={field.is_required}
      data-cy={`select-form-control-${String(field.field)}`}
    >
      <FormLabel id={`form-field-${String(field.field)}-label`}>
        {field.label}
      </FormLabel>
      <Box>
        <div className={isDisabled ? "cursor-not-allowed" : ""}>
          <Controller
            name={String(field.field)}
            disabled={isDisabled}
            control={control}
            rules={requiredRule(field)}
            render={render}
          />
        </div>
        {field.info && !error?.message ? (
          <FormHelperText>
            <span>
              {field.info} {addOption}
            </span>
          </FormHelperText>
        ) : null}
        {error?.message && (
          <FormErrorMessage>
            <span>
              {error?.message} {addOption}
            </span>
          </FormErrorMessage>
        )}
      </Box>
    </FormControl>
  );
};

const getError = (name: string, formState: FormState<{ [x: string]: any }>) => {
  return get(formState.errors, name);
};
